module.exports = __webpack_public_path__ + "media/abk/assets/images/login/czlowiek-433d0e75ee7bd217a7ffcab7b67ca5ff.jpg";